module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0070.ad8d29bd.jpg";